export default __webpack_public_path__ + "static/media/ems.875d106c.png";